import { inject } from "@angular/core";
import { UsersService } from "../services/users.service";
import { AuthService } from "../services/auth.service";
import Swal, { SweetAlertResult } from "sweetalert2";
import { ERROR_MESSAGES } from "./constants";
import { Observable } from "rxjs";

export class BaseComponent {
    // loading: boolean = false;


    success(message?: string): void {
        message = message ?? "Operación realizada satisfactoriamente";
        Swal.fire({
            toast: true, position: 'top-end', showConfirmButton: false, timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            },
            html: message, icon: 'success',
        });
    }
    async confirm(message?: string, title: string = "", textButton: string = "", allowOutsideClick: boolean = true): Promise<SweetAlertResult<any>> {
        return Swal.fire({
            title: title,
            html: message,
            confirmButtonText: textButton,
            showCancelButton: true,
            cancelButtonText: "No",
            allowOutsideClick: allowOutsideClick,
            allowEscapeKey: allowOutsideClick,

            customClass: {
                container: 'alert-container',
                confirmButton: 'alert-confirmButton'
            }
        });
    }
    async info(message?: string, title: string = "", textButton: string = "", allowOutsideClick: boolean = true, footerMessage?: string, onTutorialClick?: () => void): Promise<void> {
        await Swal.fire({
            title: title,
            html: message,
            confirmButtonText: textButton,
            allowOutsideClick: allowOutsideClick,
            allowEscapeKey: allowOutsideClick,
            footer: footerMessage ? footerMessage : undefined,
            customClass: {
                container: 'alert-container',
                confirmButton: 'alert-confirmButton'
            },
            didOpen: () => {
                const tutorialLink = Swal.getFooter()?.querySelector('a');
                if (tutorialLink && onTutorialClick) {
                    tutorialLink.addEventListener('click', (event) => {
                        Swal.close();
                        event.preventDefault();
                        onTutorialClick();
                    });
                }
            }
        });
    }
    async infoWithLogo(message?: string, title: string = "", allowOutsideClick: boolean = true, routeImg?: string, urlRedirect: string = ""): Promise<void> {
        await Swal.fire({
            imageUrl: routeImg,
            imageWidth: 280,
            imageHeight: 50,
            imageAlt: 'Custom image',
            title: `<h2 style="font-size: 22px; margin: 0;">${title}</h2>`,
            html: `
            <p style="font-size: 14px; line-height: 1.5; text-align: start; margin: 0;">
                ${message}
            </p>
            <a href="${urlRedirect}" target="_blank" style="display: inline-block; margin-top: 20px; color: #000; font-size: 14px;">
                Conocer más sobre Phoenix
            </a>
            `,
            confirmButtonText: 'Iniciar',
            allowOutsideClick: allowOutsideClick,
            allowEscapeKey: allowOutsideClick,
            customClass: {
                container: 'alert-container',
                confirmButton: 'alert-confirmButton'
            }
        });
    }

    /**
     * Extrae el ID del video de una URL de YouTube
     */
    public getYoutubeVideoId(url: string): string | null {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    }
    alert(message?: string, title: string = ""): void {
        Swal.fire({
            title: title,
            html: message,
            icon: "warning",
            customClass: {
                container: 'alert-container',
                confirmButton: 'alert-confirmButton',
                icon: 'alert-icon'
            }
        });
    }
    error(message: string): void {
        Swal.fire({
            title: "Oops !!",
            html: message,
            icon: "error",
            customClass: {
                container: 'alert-container',
                confirmButton: 'alert-confirmButton',
                icon: 'alert-icon'
            }
        });
    }

    errorDefault(err?: Error, message?: string): void {
        message = message ?? ERROR_MESSAGES.Default.message;
        Swal.fire({
            title: "Oops !!",
            text: message,
            icon: "error",
            customClass: {
                container: 'alert-container',
                confirmButton: 'alert-confirmButton',
                icon: 'alert-icon'
            }
        })
    }

    sleep(ms: number): Promise<void> {
        return new Promise(
            resolve => setTimeout(resolve, ms)
        );
    }
}   
